import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconUpDownFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillOpacity: .87,
		d: "M7 15l5 5.5 5-5.5H7zM7 9.5L12 4l5 5.5H7z"
	})
});
export default SvgIconUpDownFilter;
